import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { productsApi } from '@/lib/api-client';

export function useModifierGroups(params: Record<string, string | number | boolean | undefined> = {}) {
  return useQuery({
    queryKey: ['modifier-groups', params],
    queryFn: () => productsApi.get<{ data: any[] }>('/modifier-groups', params),
  });
}

export function useCreateModifierGroup() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => productsApi.post('/modifier-groups', data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['modifier-groups'] });
    },
  });
}

export function useUpdateModifierGroup() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }: any) => productsApi.put(`/modifier-groups/${id}`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['modifier-groups'] });
    },
  });
}

export function useDeleteModifierGroup() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, cascade }: { id: string; cascade?: boolean }) =>
      productsApi.delete(`/modifier-groups/${id}${cascade ? '?cascade=true' : ''}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['modifier-groups'] });
      queryClient.invalidateQueries({ queryKey: ['products'] });
    },
  });
}
